import { useState, useEffect, useCallback } from "react";
import moment from "moment";

// components
import AnimationLoading from "../../components/Animationloading";
import EmptyComponent from "../../components/EmptyComponent";
import { convertCurrency, numberFormat } from "../../helper";
import NavDashboard from "../../components/NavDashboard";

// apollo-client
import { GET_REPORT_PRODUCT } from "../../apollo/dashboard/query";
import { useLazyQuery } from "@apollo/client";
import "./index.css";

// react-bootrap
import { Row, Form, Col, Table, Spinner, Card } from "react-bootstrap";
import { RiMoneyDollarCircleLine } from "react-icons/ri";
import { TbCurrencyBaht, TbCurrencyKip } from "react-icons/tb";
import { BsBagCheck } from "react-icons/bs";
import PaginationsV2 from "../../components/PaginationsV2";

export default function ReportProduct() {
  const dateNow = new Date().toISOString().slice(0, 10);
  const [reportproduct, setReportProduct] = useState();
  const [reportproductTotal, setReportProductTotal] = useState();
  const [currentStartDate, setCurrentStartDate] = useState("2023-09-01");
  const [currentEndDate, setCurrentEndDate] = useState(dateNow);


  const rowsPerPage = 50;
  const [page, setPage] = useState(0);
  const pageAll = reportproductTotal > 0 ? Math.ceil(reportproductTotal / rowsPerPage) : 1;
  const handleChangePage = useCallback((newPage) => {
    setPage(newPage);
  }, []);
  // ============== > UseLazyQuery And UseMutaion <==============

  const [getreportproduct, { data: getReportproductData, loading }] =
    useLazyQuery(GET_REPORT_PRODUCT, { fetchPolicy: "cache-and-network" });

  // ============== > useEffect <==============

  useEffect(() => {
    if (getReportproductData)
      setReportProduct(getReportproductData?.reportProductOrder);
  }, [getReportproductData]);
  
  useEffect(() => {
    if (getReportproductData)
      setReportProductTotal(getReportproductData?.reportProductOrder?.total);
  }, [getReportproductData]);

  useEffect(() => {
    _filter();
  }, []);

  useEffect(() => {
    _filter();
  }, [currentStartDate, currentEndDate, page]);

  // ============== > fuctions <==============

  const _filter = async () => {
    try {
      let shopId = JSON.parse(localStorage.getItem("SHOP_DATA"))?.id;

      let _where = {
        shop: shopId,
        isDeleted: false,
      };
      // check if filter date is set
      if (currentStartDate && currentEndDate) {
        _where = {
          ..._where,
          createdAt_gte: new Date(
            moment(moment(currentStartDate).format("YYYY-MM-DD")).toISOString()
          ),
          createdAt_lt: new Date(
            moment(moment(currentEndDate).add(1, "days")).format("YYYY-MM-DD")
          ).toISOString(),
        };
      }

      // TODO: Get all order groups
      getreportproduct({
        variables: {
          skip: page * rowsPerPage,
          limit: rowsPerPage,
          orderBy: "createdAt_DESC",
          where: _where,
        },
      });
    } catch (error) {
      console.log("Error: ", error);
    }
  };




  const handleChangeStartDate = (e) => {
    setCurrentStartDate(e?.target?.value);
  };

  const handleChangeEndDate = (e) => {
    setCurrentEndDate(e?.target?.value);
  };

  return (
    <NavDashboard title="ລາຍງານການຂາຍສິນຄ້າ">
      <div className="row my-4">
        <div className="col-3">
          <div className="showProducts shadow-sm">
            <div className="boxIcon">
              <div className="iconName2">
                <BsBagCheck />
              </div>
            </div>
            <div className="boxResult">
              <h3>{reportproduct?.total ?? 0}</h3>
              <p>ຈຳນວນທັງໜົດ</p>
            </div>
          </div>
        </div>
        <div className="col-3">
          <div className="showProducts shadow-sm">
            <div className="boxIcon">
              <div className="iconName1">
                <TbCurrencyKip />
              </div>
            </div>
            <div className="boxResult">
              <h3>{numberFormat(reportproduct?.sumPrice ?? 0)} </h3>
              <p>ກີບ</p>
            </div>
          </div>
        </div>
        <div className="col-3">
          <div className="showProducts shadow-sm">
            <div className="boxIcon">
              <div className="iconName1">
                <TbCurrencyBaht />
              </div>
            </div>
            <div className="boxResult">
              <h3>{numberFormat(reportproduct?.sumBahtPrice ?? 0)} </h3>
              <p>ບາດ</p>
            </div>
          </div>
        </div>
        <div className="col-3">
          <div className="showProducts shadow-sm">
            <div className="boxIcon">
              <div className="iconName1">
                <RiMoneyDollarCircleLine />
              </div>
            </div>
            <div className="boxResult">
              <h3>{numberFormat(reportproduct?.sumUSDPrice ?? 0)} </h3>
              <p>ໂດລາ</p>
            </div>
          </div>
        </div>
      </div>

      <Card style={{ padding: "3em" }}>
        <Card.Title style={{ paddingBottom: "1em" }}>
          <Row>
            <Col className="col-6">
              <p>ລາຍງານການຂາຍ</p>
            </Col>
            <Col className="col-6 d-flex gap-4">
              <div style={{ width: "100%" }}>
                <Form.Label style={{ fontSize: "18px" }}>ເເຕ່ວັນທີ</Form.Label>
                <Form.Control
                  type="date"
                  value={currentStartDate}
                  onChange={(e) => handleChangeStartDate(e)}
                />
              </div>
              <div style={{ width: "100%" }}>
                <Form.Label style={{ fontSize: "18px" }}>ຫາວັນທີ</Form.Label>
                <Form.Control
                  type="date"
                  value={currentEndDate}
                  onChange={(e) => handleChangeEndDate(e)}
                />
              </div>
            </Col>
          </Row>
        </Card.Title>

        {loading && !getReportproductData ? (
          <AnimationLoading />
        ) : (
          <>
            {reportproduct?.data?.length > 0 ? (
              <div>
                <Table striped hover>
                  <thead>
                    <tr>
                      <th>ລຳດັບ</th>
                      <th>ປະເພດສິນຄ້າ</th>
                      <th>ຈຳນວນ</th>
                      <th>ລວມເງີນ</th>
                      <th>ສະກຸນເງີນ</th>
                    </tr>
                  </thead>
                  <tbody>
                    {reportproduct?.data?.map((pro, index) => (
                      <tr>
                        <td>{page * rowsPerPage + index + 1}</td>
                        <td>{pro?.productName}</td>
                        <td>{pro?.amount}</td>
                        <td>{numberFormat(pro?.totalPrice ?? 0)}</td>
                        <td>{convertCurrency(pro?.currency)}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
                <PaginationsV2
                count={reportproductTotal}
                rowsPerPage={rowsPerPage}
                page={page}
                pageAll={pageAll}
                onPageChange={handleChangePage}
              />
              </div>
            ) : (
              <div>
                {reportproduct?.data?.length <= 0 && (
                  <div
                    style={{
                      fontSize: "24px",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      color: "#6B7280",
                      fontWeight: "400",
                    }}>
                    <EmptyComponent />
                    <p>ຍັງບໍ່ມີລາຍງານການຂາຍສິນຄ້າ !!!</p>
                  </div>
                )}
              </div>
            )}
          </>
        )}
      </Card>
    </NavDashboard>
  );
}
